<section class="jumbotron" [ngClass]="jumbotronClasses">
  <div class="container">
    <div class="jumbotron__content">
      <app-back-link
        *ngIf="backLink"
        class="absolute block mb-auto top-4"
        [ariaLabel]="backLinkAriaLabel"
        [backLink]="backLink"
        [variant]="backLinkStyle"
        [enableHistoryNavigation]="true"
      ></app-back-link>

      <h1 class="jumbotron__content__title" aria-label="activities jumbotron">
        {{ title }}
      </h1>

      <div
        *ngIf="description"
        class="jumbotron__content__description"
        [innerHtml]="description | safeHtml"
      ></div>

      <ng-content></ng-content>
    </div>
    <app-picture
      [image]="imgDesktop"
      [imageMobile]="imgMobile"
      [isFullImage]="true"
      class="jumbotron__inner"
      classNamePicture="jumbotron__picture"
      classNameImage="jumbotron__picture__image"
      [isHp]="isHp"
    >
      ></app-picture
    >
  </div>
</section>
